import TextOption from '@activities/items/ItemActivity/components/TextOption';
import Header from '@components/Header';
import styled from '@emotion/styled';
import useItem from '@hooks/item/useItem';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

interface Params {
    itemId: string;
}

const PersonalOptionActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { itemId } = params;
  const item = useItem(itemId);
  return (
      <AppScreen>
          <Header title='퍼스널 옵션' />
          {item && (
              <Contents>
                  {item.personalOptionGroups.map((optionGroup, idx) => (
                      <TextOption optionGroup={optionGroup}
                                  noDivider={idx === 0}
                                  key={optionGroup.optionGroupId}
                                  itemId={itemId} />
                  ))}
              </Contents>
          )}
      </AppScreen>
  );
};

const Contents = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 48px;
`;

export default PersonalOptionActivity;
